import { Pipe, PipeTransform } from '@angular/core';

import {
  getFutureDiffString,
  getNowString,
  getPastDiffString,
} from '../time-diffs';

@Pipe({
  name: 'timePast',
  standalone: false,
})
export class TimePastPipe implements PipeTransform {
  transform(value: Date | string | number): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const isFuture = diffInSeconds < 0;
    const absDiffInSeconds = Math.abs(diffInSeconds);

    const minutes = Math.floor(absDiffInSeconds / 60);
    const hours = Math.floor(absDiffInSeconds / 3600);
    const days = Math.floor(absDiffInSeconds / 86400);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    const diff = {
      seconds: absDiffInSeconds,
      minutes,
      hours,
      days,
      months,
      years,
      isFuture,
    };

    if (absDiffInSeconds === 0) {
      return getNowString(diff);
    }

    return isFuture ? getFutureDiffString(diff) : getPastDiffString(diff);
  }
}
